import { getRudderstack } from '@ecomm/shared-window'
import { useEffect, useState } from 'react'

export function useRudderstackSessionId(): null | number {
  const [id, setId] = useState<null | number>(null)

  useEffect(() => {
    getRudderstack(sdk => {
      setId(sdk.getSessionId())
    })
  }, [])

  return id
}
